import { List as WarehousesList } from './List';

export default WarehousesList;
